import React from "react";

// METAPREDIC ES: native inline JSX (original DOM IDs/classes preserved).
export default function OverlayAssets() {
  return (
    <div className="es-fragment">
      <svg aria-hidden="true" height="0" style={{"position": "absolute"}} width="0">
        <defs>
          <symbol id="i-home" viewBox="0 0 24 24">
            <path d="M3 11.2 12 3.8l9 7.4V20a1 1 0 0 1-1 1h-5.2v-6.2H9.2V21H4a1 1 0 0 1-1-1z" fill="currentColor">
            </path>
            <rect fill="#fff" height="5.4" opacity=".9" width="3.2" x="10.4" y="15.6">
            </rect>
          </symbol>
          <symbol fill="none" id="i-ai" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="7.5" cy="16.5" r="2.2">
            </circle>
            <circle cx="13" cy="9.5" r="2.2">
            </circle>
            <path d="M8.9 14.8l2.7-3.5M15 8.3l4.5-3M19.5 5.3l1 2.4M3 21.5h9">
            </path>
          </symbol>
          <symbol fill="none" id="i-esc" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M2.5 19.5h5L16 8.5h5.5">
            </path>
            <path d="M2.5 15h3.2L14 4.5h4">
            </path>
            <circle cx="12" cy="13.5" fill="currentColor" r="1.4">
            </circle>
          </symbol>
          <symbol fill="none" id="i-cmms" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <rect height="17" rx="2" width="16" x="4" y="4">
            </rect>
            <path d="M9 2.8h6v3H9zM8 11h8M8 15h5">
            </path>
          </symbol>
          <symbol fill="none" id="i-report" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M4 21V4M4 21h17M8.5 17v-6M13 17V7M17.5 17v-3.5">
            </path>
          </symbol>
          <symbol fill="none" id="i-gear" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="3">
            </circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z">
            </path>
          </symbol>
          <symbol id="i-sun" viewBox="0 0 24 24">
            <circle cx="12" cy="12" fill="currentColor" r="5">
            </circle>
            <g stroke="currentColor" strokeLinecap="round" strokeWidth="2">
              <path d="M12 1.5v2.2M12 20.3v2.2M1.5 12h2.2M20.3 12h2.2M4.6 4.6l1.5 1.5M17.9 17.9l1.5 1.5M4.6 19.4l1.5-1.5M17.9 6.1l1.5-1.5">
              </path>
            </g>
          </symbol>
          <symbol id="i-user" viewBox="0 0 24 24">
            <circle cx="12" cy="12" fill="#1b2633" r="11.5">
            </circle>
            <circle cx="12" cy="9.3" fill="#e8eef5" r="3.8">
            </circle>
            <path d="M4.8 19.2c1.5-3 4.2-4.6 7.2-4.6s5.7 1.6 7.2 4.6A11 11 0 0 1 12 23.5a11 11 0 0 1-7.2-4.3z" fill="#e8eef5">
            </path>
          </symbol>
          <symbol fill="none" id="i-search" stroke="currentColor" strokeLinecap="round" strokeWidth="2.2" viewBox="0 0 24 24">
            <circle cx="10.5" cy="10.5" r="7">
            </circle>
            <path d="M20.5 20.5l-5-5">
            </path>
          </symbol>
          <symbol fill="none" id="i-target" stroke="currentColor" strokeLinecap="round" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="7">
            </circle>
            <circle cx="12" cy="12" r="2.6">
            </circle>
            <path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3">
            </path>
          </symbol>
          <symbol fill="none" id="i-nav" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M3 11l18-8-8 18-2-8z">
            </path>
          </symbol>
          <symbol fill="none" id="i-pin" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="6.5" r="2.6">
            </circle>
            <path d="M8 21l2-7h4l2 7M7.5 12.5l4.5-2.5 4.5 2.5">
            </path>
          </symbol>
          <symbol fill="none" id="i-list" stroke="currentColor" strokeLinecap="round" strokeWidth="2.2" viewBox="0 0 24 24">
            <path d="M8 6h13M8 12h13M8 18h13M3.5 6h.5M3.5 12h.5M3.5 18h.5">
            </path>
          </symbol>
          <symbol fill="none" id="i-chev" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" viewBox="0 0 24 24">
            <path d="M9 5l7 7-7 7">
            </path>
          </symbol>
          <symbol fill="none" id="i-arrow" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" viewBox="0 0 24 24">
            <path d="M4 12h16M13 5l7 7-7 7">
            </path>
          </symbol>
          <symbol id="i-chat" viewBox="0 0 24 24">
            <path d="M12 3C6.5 3 2.5 6.6 2.5 11c0 2.5 1.3 4.7 3.4 6.2L5 21.3l4.4-2.4c.8.2 1.7.3 2.6.3 5.5 0 9.5-3.6 9.5-8.1S17.5 3 12 3z" fill="#fff">
            </path>
            <circle cx="8" cy="11" fill="#1d64d8" r="1.4">
            </circle>
            <circle cx="12" cy="11" fill="#1d64d8" r="1.4">
            </circle>
            <circle cx="16" cy="11" fill="#1d64d8" r="1.4">
            </circle>
          </symbol>
          <symbol id="i-alert" viewBox="0 0 24 24">
            <path d="M12 2.8 22.5 21h-21z" fill="#fff">
            </path>
            <path d="M12 9v5.5" stroke="#c9303d" strokeLinecap="round" strokeWidth="2.4">
            </path>
            <circle cx="12" cy="17.6" fill="#c9303d" r="1.4">
            </circle>
          </symbol>
          <symbol fill="none" id="i-bearing" stroke="#fff" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="8.5">
            </circle>
            <circle cx="12" cy="12" r="3">
            </circle>
            <g fill="#fff" stroke="none">
              <circle cx="12" cy="6.2" r="1.5">
              </circle>
              <circle cx="17" cy="9.1" r="1.5">
              </circle>
              <circle cx="17" cy="14.9" r="1.5">
              </circle>
              <circle cx="12" cy="17.8" r="1.5">
              </circle>
              <circle cx="7" cy="14.9" r="1.5">
              </circle>
              <circle cx="7" cy="9.1" r="1.5">
              </circle>
            </g>
          </symbol>
          <symbol fill="none" id="i-chain" stroke="#fff" strokeLinecap="round" strokeWidth="2.2" viewBox="0 0 24 24">
            <rect height="8" rx="4" width="10" x="2.5" y="8">
            </rect>
            <rect height="8" rx="4" width="10" x="11.5" y="8">
            </rect>
          </symbol>
          <symbol fill="none" id="i-fit" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" viewBox="0 0 24 24">
            <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5">
            </path>
          </symbol>
          <symbol id="i-play" viewBox="0 0 24 24">
            <path d="M8 5.5v13l11-6.5z" fill="currentColor">
            </path>
          </symbol>
          {/* C-8: 고장 신고/수리 필요 — 렌치 + 경고 표시 */}
          <symbol id="i-fault-report" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M13.8 3.1a5.5 5.5 0 0 0-6.9 7L2.7 14.3a2.5 2.5 0 0 0 3.5 3.5l4.2-4.2a5.5 5.5 0 0 0 7-6.9l-3.3 3.3-3.3-3.3z" />
            <path d="M18.6 13.4 23 21.1a.8.8 0 0 1-.7 1.2h-8.8a.8.8 0 0 1-.7-1.2l4.4-7.7a.8.8 0 0 1 1.4 0z" fill="#111827" />
            <path d="M17.9 16.4v2.5" />
            <circle cx="17.9" cy="20.4" r=".45" fill="currentColor" stroke="none" />
          </symbol>
        </defs>
      </svg>
      <div aria-labelledby="modalTitle" aria-modal="true" className="modalBack" id="modalBack" role="dialog">
        <div className="modal">
          <div className="modalHeader">
            <div style={{"minWidth": "0"}}>
              <nav aria-label="정보 계층" className="crumb" id="crumb">
              </nav>
              <h2 id="modalTitle">
                설비 정밀진단
              </h2>
            </div>
            <button className="close" id="closeModal">
              닫기 ✕
            </button>
          </div>
          <p className="sub" id="modalSub">
          </p>
          <div className="detailGrid">
            <div className="detailBox">
              <small>
                종합 건강지수 (HI)
              </small>
              <strong id="mHi">
                -
              </strong>
            </div>
            <div className="detailBox">
              <small>
                AI 위험등급
              </small>
              <strong id="mGrade">
                -
              </strong>
            </div>
            <div className="detailBox">
              <small>
                잔여수명(RUL) 예측
              </small>
              <strong id="mRul">
                -
              </strong>
            </div>
            <div className="detailBox">
              <small>
                이상 점수 (0–1)
              </small>
              <strong id="mAnom">
                -
              </strong>
            </div>
          </div>
          <div className="diag">
            <section className="twinBox">
              <div className="boxHead">
                <strong>
                  <span className="lvl">
                    L3
                  </span>
                  부품 상태 · 디지털 트윈
                </strong>
              </div>
              <div id="twinWrap">
              </div>
            </section>
            <section className="chartBox">
              <div className="boxHead">
                <strong>
                  <span className="lvl">
                    L4
                  </span>
                  센서 진단
                </strong>
                <div aria-label="진단 차트" className="seg mini" id="diagTabs" role="group">
                  <button className="on" data-d="trend">
                    HI 추이·RUL
                  </button>
                  <button data-d="fft">
                    FFT 스펙트럼
                  </button>
                </div>
              </div>
              <canvas id="modalPlot">
              </canvas>
              <small className="chartNote" id="chartNote">
              </small>
            </section>
          </div>
          <p className="cause" id="mCause">
          </p>
          <div className="envNote" hidden={true} id="mEnv">
          </div>
          <div className="actions">
            <button className="danger" id="actDispatch">
              현장 출동 지시
            </button>
            <button id="actSlow">
              운행 속도 감속 권고
            </button>
            <button id="actStock">
              예비 부품 재고 확인
            </button>
            <button className="primary" id="createWork">
              CMMS 작업지시 생성
            </button>
            <button id="ackAlarm">
              경보 확인 처리
            </button>
          </div>
          <p aria-live="polite" className="demoNote" id="modalFeedback">
          </p>
        </div>
      </div>
      <div aria-labelledby="ramsTitle" aria-modal="true" className="modalBack" id="ramsBack" role="dialog">
        <div className="modal ramsModal">
          <div className="modalHeader">
            <div>
              <h2 id="ramsTitle">
                RAMS 상세 — 최근 30일
              </h2>
              <p className="sub">
                신뢰성·가용성·보전성·안전성 · EN 50126 RAMS 체계 참고 · 시연용 예시 데이터
              </p>
            </div>
            <button className="close" id="closeRams">
              닫기 ✕
            </button>
          </div>
          <div className="tableBox ramsTableBox">
            <table className="risk ramsTable">
              <thead>
                <tr>
                  <th>
                    구분
                  </th>
                  <th>
                    운행 설비
                  </th>
                  <th>
                    고장 정지
                  </th>
                  <th>
                    MTBF
                  </th>
                  <th>
                    MTTR
                  </th>
                  <th>
                    가동률
                  </th>
                  <th>
                    안전부품 이상
                  </th>
                  <th>
                    비상정지
                  </th>
                  <th>
                    승객 안전사고
                  </th>
                </tr>
              </thead>
              <tbody id="ramsRows">
              </tbody>
            </table>
          </div>
          <div className="ramsDefs" id="ramsDefs">
          </div>
          <div className="actions">
            <button className="primary" id="ramsReport">
              월간 RAMS 보고서 생성
            </button>
            <button id="ramsSafety">
              안전부품 이상 역 보기
            </button>
          </div>
          <p aria-live="polite" className="demoNote" id="ramsFeedback">
          </p>
        </div>
      </div>
      <div className="toast" id="toast" role="status">
      </div>
    </div>
  );
}
